

export const getVenueDetails = (data) => {
  if (data.eventType === "virtual") {
    return {
      zoomLink: data.zoomLink,
      meetingId: data.meetingId,
      passcode: data.passcode,
    }
  } else {
    return {
      address: data.address,
      placeName: data.placeName,
    }

  }
}

export const parseCampaignPayload = (values, propertyName) => {
  let payload = {
    ...values,
    smsEnabled: false,
    friendInviteMenuBody: values.friendInviteMenuBody.replace(/\%reward\%/, "$" + values.reward),
    emailBody: nlToBr(values.emailBody.replace(/\%reward\%/, "$" + values.reward)),
    emailSms: parseBody(values.emailSms.replace(/\%reward\%/, "$" + values.reward)),
    bannerText: values.bannerText.replace(/\%reward\%/, "$" + values.reward),
    pitchMessage: values.pitchMessage.replace(/\%reward\%/, "$" + values.reward),
    residentEnrollHeader: values.residentEnrollHeader.replace(/\%reward\%/, "$" + values.reward),
    residentEnrollFooter: values.residentEnrollFooter.replace(/\%reward\%/, "$" + values.reward),
    residentInviteEmailBody: nlToBr(values.residentInviteEmailBody.replace(/\%reward\%/, "$" + values.reward)),
    residentInviteSms: parseBody(values.residentInviteSms.replace(/\%property\%/g, propertyName)),
    residentDiscountEmailBody: nlToBr(values.residentDiscountEmailBody.replace(/\%reward\%/, "$" + values.reward)),
    residentDiscountEmailSms: parseBody(values.residentDiscountEmailSms.replace(/\%reward\%/, "$" + values.reward)),
    residentThankYouEmailBody: nlToBr(values.residentThankYouEmailBody.replace(/\%reward\%/, "$" + values.reward)),
    landingPageContent: nlToBr(values.landingPageContent),
    reward: parseFloat(values.reward)
  }
  return payload;
}

export const parseBody = (text) => {
  var newL = /\n/g;
  return text.replace(newL, '<br/>');
}

export const nlToBr = parseBody;

export const brToNl = (str) => {
  return str.replace(/<\s*\/?br\s*[\/]?>/g, "\n");
}

export const getDefaultValues = (props, defaultReward, rewardFields) => {
  let values = {
    propertyId: window.location.pathname.split("/")[1],
    title: props.title,
    reward: props.reward,
    image: props.image,
    emailSubject: props.emailSubject,
    emailBody: brToNl(props.emailBody, true),
    emailSms: brToNl(props.emailSms, true),
    ctaDesign: props.ctaDesign,
    ctaText: props.ctaText,
    bannerText: brToNl(props.bannerText, true),
    pitchMessage: brToNl(props.pitchMessage, true),
    residentEnrollHeader: brToNl(props.residentEnrollHeader, true),
    residentEnrollFooter: brToNl(props.residentEnrollFooter, true),
    emailEnabled: props.emailEnabled,
    smsEnabled: props.smsEnabled,
    facebookEnabled: props.facebookEnabled,
    twitterEnabled: props.twitterEnabled,
    residentInviteImage: props.residentInviteImage,
    residentDiscountImage: props.residentDiscountImage,
    residentInviteEmailSubject: props.residentInviteEmailSubject,
    residentInviteEmailBody: brToNl(props.residentInviteEmailBody, true),
    residentInviteSms: brToNl(props.residentInviteSms, true),
    residentInviteSocialContent: props.residentInviteSocialContent,
    residentDiscountEmailSubject: props.residentDiscountEmailSubject,
    residentDiscountEmailBody: brToNl(props.residentDiscountEmailBody, true),
    residentDiscountEmailSms: brToNl(props.residentDiscountEmailSms, true),
    tourCtaText: props.tourCtaText,
    tourCtaUrl: props.tourCtaUrl,
    contactCtaText: props.contactCtaText,
    contactCtaUrl: props.contactCtaUrl,
    friendInviteEmailHeader: props.friendInviteEmailHeader,
    rewardEmailHeader: props.rewardEmailHeader,
    friendInviteMenuHeader: props.friendInviteMenuHeader,
    friendInviteMenuBody: props.friendInviteMenuBody,
    popupTitle: props.popupTitle,
    popupMessage: props.popupMessage,
    residentBannerTitle: props.residentBannerTitle,
    residentThankYouEmailSubject: props.residentThankYouEmailSubject,
    residentThankYouEmailTitle: props.residentThankYouEmailTitle,
    residentThankYouEmailBody: brToNl(props.residentThankYouEmailBody, true),
    residentThankYouImage: props.residentThankYouImage,
    landingPageContent: brToNl(props.landingPageContent, true),
    landingPageImage: props.landingPageImage,
    landingPageTitle: props.landingPageTitle,
    emailValidationStatus: props.emailValidationStatus
  }

  return values
}

